import { Box, Chip, IconButton, Stack, Typography } from '@mui/joy';
import { Refresh } from '@mui/icons-material';
import { useAuth } from '@/context/AuthContext';

const ROLE_COLORS: Record<string, 'primary' | 'success' | 'warning'> = {
  admin: 'primary',
  manager: 'success',
  employee: 'warning',
};

interface WelcomeHeaderProps {
  onRefresh?: () => void;
}

export default function WelcomeHeader({ onRefresh }: WelcomeHeaderProps) {
  const { user } = useAuth();
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
      <Box>
        <Stack direction="row" alignItems="center" spacing={1.5} mb={0.5}>
          <Typography level="h2">
            Welcome back, {user?.first_name}!
          </Typography>
          <Chip
            size="sm"
            variant="soft"
            color={ROLE_COLORS[user?.role || 'employee'] || 'neutral'}
          >
            {user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : ''}
          </Chip>
        </Stack>
        <Typography level="body-sm" color="neutral">
          {today}
        </Typography>
      </Box>
      {onRefresh && (
        <IconButton variant="outlined" size="sm" onClick={onRefresh} aria-label="Refresh dashboard">
          <Refresh />
        </IconButton>
      )}
    </Stack>
  );
}
